import { render, staticRenderFns } from "./PreAutoScroll.vue?vue&type=template&id=3b210235"
import script from "./PreAutoScroll.vue?vue&type=script&lang=js"
export * from "./PreAutoScroll.vue?vue&type=script&lang=js"
import style0 from "./PreAutoScroll.vue?vue&type=style&index=0&id=3b210235&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports